import SystemApiBase from "../base/SystemApiBase";

import type { OkResponse } from "@/schemas/api/ok";
import type {
  AppInstallRequest,
  DeviceTrackingRequest,
  LoggingNotificationOpenRequest,
} from "@/schemas/api/tracking";

export class LoggingService extends SystemApiBase {
  public constructor() {
    super("/log");
  }

  public logNotificationOpen(
    request: LoggingNotificationOpenRequest,
  ): Promise<OkResponse> {
    return this.post<OkResponse>("/notification", request);
  }

  public collectDeviceInformation(
    request: DeviceTrackingRequest,
  ): Promise<OkResponse> {
    return this.post<OkResponse>("/device", request);
  }

  public logAppInstall(request: AppInstallRequest): Promise<OkResponse> {
    return this.post<OkResponse>("/app_install", request);
  }
}
